import { Typography,Grid} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import SelectConfig from "./SelectConfig";

const MetronomeForm = ({config, setConfig, setErrorMetronome, errorMetronome, version}) => {
    const { t } = useTranslation();

    const handleConfChange = (e, key) => {
        var newValue = e.target.value
        setConfig((prevConfig) => ({
                ...prevConfig,
                device_setting: {
                    ...prevConfig?.device_setting,
                    metronome: {
                    ...prevConfig.device_setting.metronome,
                    [key]: newValue,
                    },
                },
            }));

    }

    return (
        <>
        <Grid item xs={12}>
              <Typography
                color="secondary"
                style={{
                  fontWeight: 500,
                  fontSize: 22,
                  lineHeight: "30px",
                  marginTop: 18,
                }}>
                {t("devices.setUp.metronome.title")}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
              <SelectConfig
                label={t("device.details.config.metronome.ratio_adult")}
                value={config?.device_setting?.metronome?.ratio_adult}
                onChange={(e) => handleConfChange(e, 'ratio_adult')}
                kv
                values={[
                  { key: 0, value: t("devices.setUp.ratioAdultValue0") },
                  { key: 1, value: t("devices.setUp.ratioAdultValue1") },
                  { key: 2, value: t("devices.setUp.ratioAdultValue2") },
                ]}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
              <SelectConfig
                label={t("device.details.config.metronome.ratio_pediatric")}
                value={config?.device_setting?.metronome?.ratio_pediatric}
                onChange={(e) => handleConfChange(e, 'ratio_pediatric')}
                kv
                values={[
                  { key: 0, value: t("devices.setUp.ratioAdultValue0") },
                  { key: 1, value: t("devices.setUp.ratioAdultValue1") },
                  { key: 2, value: t("devices.setUp.ratioAdultValue2") },
                ]}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} xl={4}>
              <SelectConfig
                label={t("devices.setUp.rateLabel")}
                value={config?.device_setting?.metronome?.rate}
                onChange={(e) => handleConfChange(e, 'rate')}
                kv
                values={[
                  { key: 0, value: t("cpm", { value: 100 }) },
                  { key: 1, value: t("cpm", { value: 110 }) },
                  { key: 2, value: t("cpm", { value: 120 }) },
                ]}
              />
            </Grid>
        </>
    );
};

export default MetronomeForm;